import React from "react";

// Custom Hummingbird SVG mark - used in nav, empty states, and decoratively.
export const Hummingbird = ({ size = 28, className = "", color = "#0F5C60", accent = "#C0324F" }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        {/* Body */}
        <path
            d="M14 38 C 18 30, 28 26, 36 26 L 48 22 L 44 30 C 44 30, 50 32, 50 36 C 50 40, 44 42, 40 40 C 36 42, 28 42, 22 40 L 14 38 Z"
            fill={color}
        />
        {/* Beak */}
        <path d="M48 22 L 58 18 L 50 24 Z" fill={color} />
        {/* Eye */}
        <circle cx="42" cy="30" r="1.4" fill="#F9F8F3" />
        {/* Wing */}
        <path
            d="M 24 28 C 18 14, 8 18, 10 30 C 14 28, 20 30, 24 32 Z"
            fill={accent}
            opacity="0.95"
        />
        {/* Tail */}
        <path d="M 14 38 L 6 42 L 12 36 L 6 36 L 12 34 Z" fill={color} opacity="0.8" />
    </svg>
);

export const HummingbirdMark = ({ className = "" }) => (
    <div className={`inline-flex items-center gap-2 ${className}`}>
        <Hummingbird size={28} />
        <span className="font-display font-semibold tracking-tight text-[#1E2623] text-lg">
            Shawna&apos;s Flight Plan
        </span>
    </div>
);

export default Hummingbird;
